export const isMinutesInputInvalid = (value: string): boolean => {
  const trimmed = value.trim();

  if (!trimmed) {
    return false;
  }

  const parsed = Number(trimmed);

  return !Number.isInteger(parsed) || parsed < 0;
};
